export const PATH_KNOWLEDGE = '/knowledge/:category(all|diet|tips|workouts)';
export const PATH_KNOWLEDGE_ARTICLE = '/knowledge/:article';

export const PATH_ALL_ARTICLES = '/knowledge/all';
export const PATH_CATEGORY_NUTRITION = '/knowledge/diet';
export const PATH_CATEGORY_TIPS = '/knowledge/tips';
export const PATH_CATEGORY_EXCERCISE = '/knowledge/workouts';
